import React from "react";
import NightAuditPayments from "./NightAuditPayments";
import NightAuditPaymentsSummary from "./NightAuditPaymentsSummary";

class NightAuditPaymentsWorkspace extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <div>
        <div className="alert alert-warning show">
          <h4 style={{textAlign: 'center'}}><strong>{I18n.t('all_payments_listed_helper_text')}</strong></h4>
        </div>
        <NightAuditPaymentsSummary {...this.props} />
        <NightAuditPayments {...this.props}/>
      </div>
    )

  };
};

export default NightAuditPaymentsWorkspace